import { createApi } from '@reduxjs/toolkit/query/react';

import {
  ContactShape,
  ContactsResponseShape,
  ContactTypeResponseShape,
} from 'models/contacts';
import { baseQuery } from '..';

export const ContactsApi = createApi({
  reducerPath: 'contactsApi',
  tagTypes: ['contacts', 'contact', 'contact-types'],
  baseQuery,
  endpoints: (builder) => ({
    getContact: builder.query<ContactShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['contact'],
    }),
    getContacts: builder.query<ContactsResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['contacts'],
    }),
    getContactTypes: builder.query<ContactTypeResponseShape, string>({
      query: (url) => ({
        url: url,
      }),
      providesTags: ['contact-types'],
    }),
  }),
});

export const {
  useGetContactsQuery,
  useGetContactQuery,
  useGetContactTypesQuery,
} = ContactsApi;
